// Navbar Component
function Navbar() {
    return (
      <nav style={{ padding: '10px', background: '#007bff', color: '#fff' }}>
        <a href="/" style={{ marginRight: '15px', color: '#fff' }}>Home</a>
        <a href="/bacteria-logs" style={{ marginRight: '15px', color: '#fff' }}>Bacteria Test</a>
        <a href="/devices" style={{ marginRight: '15px', color: '#fff' }}>Devices-Logs   </a>
        <a href="/eau" style={{ marginRight: '15px', color: '#fff' }}>EAU   </a>
        <a href="/devices/scwa00007" style={{ marginRight: '15px', color: '#fff' }}>  Device Report</a>
        <a href="/device/scwa00007" style={{ marginRight: '15px', color: '#fff' }}> Device Instruction</a> 
      </nav>
    );
  }
  export default Navbar;
  
